if(!customElements.get('v3-nosto-collection')) {
  const SIZE_MAP_ORDER = {
    "number": 1,
    'o/s': 2,
    'xs': 3,
    'xs/s': 4,
    's': 5,
    'm': 6,
    'm/l': 7,
    'l': 8,
    'xl': 9,
    'xl/xxl': 10,
    'xxl': 11,
    'xxxl': 12,
  }
  class V3NostoCollection extends HTMLElement {
    constructor() {
      super();

      this.eventsController;
      this.search = this.dataset.search;
      this.collectionSize = 24;
      this.collectionArray = [];
      this.exposedFilters = this.getAttribute('exposed-filters').split(', ');
      this.hiddenFilters = this.getAttribute('hidden-filters').split(', ');
      this.openFilters = JSON.parse(this.dataset.openFilters) || [];
      this.swatchFilters = JSON.parse(this.dataset.swatchFilters) || [];
      this.filterOrder = this.dataset.filterOrder ? JSON.parse(this.dataset.filterOrder) : null;

      //Product Grid
      this.productGrid = this.querySelector('[data-collection-grid]');

      //Filters Bar
      this.gridSizeSelector = this.querySelectorAll('input[name="layout-selection"]');
      this.initialGridSize = localStorage.getItem('CollectionGridSize');
      this.activeFiltersContainer = this.querySelector('[data-active-filters');

      //Filters
      this.sortSelects = this.querySelectorAll('[data-sort-options]');
      this.filtersContainer = this.querySelector('[data-filters-container]');
      this.filtersList = this.querySelector('[data-collection-filters]');
      this.filtersTemplate = this.filtersContainer.querySelector('template').content.cloneNode(true);
      this.desktopFilterToggleBtn = this.querySelector('[data-desktop-toggle-filter]');
      this.mobileFilterToggleBtn = this.querySelector('[data-mobile-toggle-filter]');
      this.mobileFilterClear = this.filtersContainer.querySelector('[data-clear-all]');
      this.mobileCloseFilters = this.filtersContainer.querySelectorAll('[data-close-filters]');
      this.visualFilters = this.querySelector('#nosto-visual-filters');

      // Pagination
      this.loadMoreBtn = this.querySelector('[data-load-more][data-direction="after"]');
      this.loadPreviousBtn = this.querySelector('[data-load-more][data-direction="before"]');
      this.itemsCount = this.querySelector('[data-items-count]');
      this.itemsTotal = this.querySelector('[data-items-total]');
    }

    connectedCallback() {
      this.eventsController = new AbortController();
      this.abortSignal = this.eventsController.signal;
      this.intersectionObserver = new IntersectionObserver(this.loadPreviousHandler.bind(this), {
        rootMargin: "900px",
        threshold: 0,
      })

      this.slotsPositions = this.dataset.slotPositions == '' ? null : JSON.parse(this.dataset.slotPositions);
      this.slotsIds = this.dataset.slotIds == '' ? null : JSON.parse(this.dataset.slotIds);
      this.slotsWidths = this.dataset.slotWidths == '' ? null : JSON.parse(this.dataset.slotWidths);

      this.desktopFilterToggleBtn.addEventListener('click', this.toggleFilterDrawerDesktop.bind(this),{
        signal: this.abortSignal.signal
      })

      this.gridSizeSelector.forEach(selector => {
        selector.addEventListener('change', this.onGridSizeSelectorChange.bind(this),{
          signal: this.abortSignal.signal
        })
      })

      this.sortSelects.forEach(select => {
        select.addEventListener("change", this.onSortChange.bind(this), {
          signal: this.abortSignal.signal
        })
      })

      this.productGrid.addEventListener('click', this.onCardClicked.bind(this), {
        signal: this.abortSignal.signal
      })

      this.activeFiltersContainer.addEventListener('click', this.onFilterRemoveClick.bind(this), {
        signal: this.abortSignal.signal
      });

      this.loadMoreBtn.addEventListener('click', this.onLoadNextClick.bind(this), {
        signal: this.abortSignal.signal
      });

      this.loadPreviousBtn.addEventListener('click', this.onLoadPreviousClick.bind(this), {
        signal: this.abortSignal.signal
      });

      this.filtersContainer.addEventListener('change', this.onFilterChange.bind(this), {
        signal: this.abortSignal.signal
      })

      this.filtersContainer.addEventListener('click', this.onFiltersButtonClick.bind(this), {
        signal: this.abortSignal.signal
      })

      this.mobileFilterToggleBtn.addEventListener('click', this.toggleFilterDrawerMobile.bind(this), {
        signal: this.abortSignal.signal
      })

      this.mobileCloseFilters.forEach((button) => {
        button.addEventListener('click', this.toggleFilterDrawerMobile.bind(this), {
          signal: this.abortSignal.signal
        })
      })

      if(this.visualFilters) {
        this.visualFilters.addEventListener('change', this.onVisualFilterClick.bind(this), {
          signal: this.abortSignal.signal
        })
      }

      this.gendered = this.dataset.gendered;

      this.setGridSize(this.initialGridSize || 'small');

      const urlObject = new URL(document.location.href);
      const page = urlObject.searchParams.get('page');

      this.getCollectionData({
        collection_reset: true,
        collection_from: Math.max(this.collectionSize * page - this.collectionSize, 0)
      });
    }

    onGridSizeSelectorChange(evt) {
      this.setGridSize(evt.target.value);
    }

    setGridSize(gridSize) {
      const currentSelector = Array.from(this.gridSizeSelector).find(el => {
        return el.value == gridSize
      });
      currentSelector.checked = true;
      localStorage.setItem('CollectionGridSize', gridSize);

      if(gridSize == 'small') {
        this.classList.add('collection--small');
        this.classList.remove('collection--large');
      } else {
        this.classList.add('collection--large');
        this.classList.remove('collection--small');
      }
    }

    async getCollectionData({
      collection_from = 0,
      collection_reset = false,
      collection_size = this.collectionSize,
      collection_direction = null,
    } = {}) {
      let urlObject = new URL(document.location.href);

      const filters = urlObject.searchParams.getAll('f');
      const sort = urlObject.searchParams.get('sort');
      let structuredFilters = {};
      let requestFilters = []

      filters.forEach(filter => {
        const filterParts = filter.split(':');
        if( structuredFilters[filterParts[0]] ) {
          structuredFilters[filterParts[0]] += `, ${filterParts[1]}`
        } else {
          structuredFilters[filterParts[0]] = filterParts[1]
        }
      })

      Object.keys(structuredFilters).forEach(key => {
        requestFilters.push({
          field: key,
          value: structuredFilters[key].split(", ")
        })
      })

      let trackType = "category";
      let apiOptions = {};

      // @todo validate loadprevious working 50%

      apiOptions.products = {
        facets: ["*"],
        currencyFormat: window._currency,
        fields: [
          "name",
          "price",
          "listPrice",
          "url",
          "imageUrl",
          "alternateImageUrls",
          "customFields.key",
          "customFields.value",
          "categories",
          "tags1",
        ],
        filter: requestFilters,
        size: collection_size,
        from: collection_from,
      }
      trackType = "category";

      if(this.search != "") {
        apiOptions.query = this.search;
        trackType = 'serp';
      } else {
        apiOptions.products.categoryId = this.dataset.collection;
      }

      if(sort) {
        const sortParts = sort.split(':');
        apiOptions.products.sort = {
          field: sortParts[0],
          order: sortParts[1]
        }
      }

      await nostojs((api) => {
        api.search(apiOptions, {
          track: trackType,
          redirect: true
        }).then((response) => {
          let products = response.products.hits;

          if(collection_direction == 'before') {
            products.reverse();
          }

          let container = this.querySelector('[data-collection-grid]');

          if(collection_reset) {
            container.innerHTML = "";
          }

          let metafields = [];
          let currentPage = Math.ceil((products.length + response.products.from) / collection_size);

          let sIndex = collection_direction == 'before' ? collection_from + response.products.hits.length : collection_from;

          products = products.map((nostoItem, index) => {
            if(collection_direction == 'before') {
              if(index > 0) {
                sIndex -= 1;
              }
            } else {
              sIndex += 1;
            }

            nostoItem.page = currentPage;
            nostoItem.sIndex = sIndex;
            nostoItem.cardPosition = `P${currentPage}C${sIndex}`;
            nostoItem.videoDesktop = null;
            nostoItem.videoMobile = null;
            nostoItem.videoUnisex = null;
            nostoItem.videoUnisex_womens_image_position = null;
            nostoItem.videoUnisex_mens_image_position = null;
            nostoItem.videoUnisex_mens_plp_desktop_video = null;
            nostoItem.videoUnisex_mens_plp_mobile_video = null;

            nostoItem.customFields.forEach((field, i) => {
              if(field.key == "images-image_icon") {
                metafields.push(field);
              }
              if (field.key == "video-plp_desktop_video") {
                let video = JSON.parse(field.value);
                nostoItem.videoDesktop = video[0].src;
              }
              if (field.key == "video-plp_mobile_video") {
                let video = JSON.parse(field.value);
                nostoItem.videoMobile = video[0].src;
              }
              if (field.key == "video-unisex") {
                nostoItem.videoUnisex = field.value;
              }
              if (field.key == "video-unisex_womens_image_position") {
                nostoItem.videoUnisex_womens_image_position = parseInt(
                  field.value
                );
              }
              if (field.key == "video-unisex_womens_hover_image_position") {
                nostoItem.videoUnisex_womens_hover_image_position = parseInt(
                  field.value
                );
              }
              if (field.key == "video-unisex_mens_image_position") {
                nostoItem.videoUnisex_mens_image_position = parseInt(
                  field.value
                );
              }
              if (field.key == "video-unisex_mens_hover_image_position") {
                nostoItem.videoUnisex_mens_hover_image_position = parseInt(
                  field.value
                );
              }
              if (field.key == "video-unisex_mens_plp_dekstop_video") {
                let video = JSON.parse(field.value);
                nostoItem.videoUnisex_mens_plp_desktop_video = video[0].src;
              }
              if (field.key == "video-unisex_mens_plp_mobile_video") {
                let video = JSON.parse(field.value);
                nostoItem.videoUnisex_mens_plp_mobile_video = video[0].src;
              }
            })

            nostoItem.metafields = metafields;
            delete nostoItem.customFields;

            if(document.location.pathname.indexOf('/collections/') > -1) {
              nostoItem.url = nostoItem.url.replace('/products', document.location.pathname + '/products');
            }

            let categories = nostoItem.categories?.map((category) => category.toLowerCase());
            let collectionTitle = "";
            let collectionHandle = "";
            categories?.forEach((category) => {
              if(category.startsWith("collection - ")) {
                collectionTitle = category;
              }
            })

            if(collectionTitle != "") {
              collectionHandle = collectionTitle.replaceAll(/\W/gm, '-').replaceAll(/-+/gm, '-');
              if(this.collectionArray.indexOf(collectionHandle) === -1) {
                this.collectionArray.push(collectionHandle);
              }
            }
            return nostoItem;
          })

          this.buildProducts({
            products,
            direction: collection_direction
          });

          this.buildPromoSlots.call(this)

          this.buildFilters({ filters: response.products.facets });

          this.buildLoadButtons({
            info: response.products,
            direction: collection_direction,
          });

          this.updateSortSelectors(sort);

          this.checkLocationHash()
          if(collection_direction == 'before') {
            this.fixScrollPosition();
          }
        })
      })
    }

    checkLocationHash() {
      const hash = document.location.hash;

      if(!hash) return;

      const card = this.productGrid.querySelector(hash);

      if(card) {
        card.scrollIntoView({
          block: "center"
        })

        const url = new URL(document.location.href);
        url.hash = "";

        history.replaceState('', null, url.toString());
      }
    }

    buildFilters({
      filters = []
    } = {}) {
      const allowedFacets = ["Category", "Size", "Color", "Fit", ...this.exposedFilters];
      const activeFilters = [];

      this.filtersList.innerHTML = "";

      filters.forEach(filter => {
        if(!allowedFacets.includes(filter.name)) return;
        const isSwatchFilter = this.swatchFilters.includes(filter.name);
        const filterEl = this.filtersTemplate.cloneNode(true);
        const filterGroup = filterEl.querySelector('.filter__group');
        filterGroup.setAttribute('data-name', filter.name);

        if(this.hiddenFilters.includes(filter.name)) {
          filterGroup.style.display = "none";
        }

        if(this.openFilters.includes(filter.name)) {
          filterGroup.setAttribute('open', 'true');
        }

        filterEl.querySelector('[data-filter-group-title]').innerText = filter.name
        const filterListContainer = filterEl.querySelector('[data-filter-option-list]');
        let sortedFilters = filter.data;

        if(filter.name == 'Size') {
          sortedFilters = this.sortFilterValues(filter.data, SIZE_MAP_ORDER);
        } else {
          if(this.filterOrder != null && this.filterOrder[filter.name]) {
            sortedFilters = this.sortFilterValues(filter.data, this.filterOrder[filter.name])
          }
        }

        filter.data.forEach((filterObject) => {
          if(filterObject.value.indexOf('||') > -1) {
            return;
          }

          if(filterObject.selected) {
            activeFilters.push({
              category: filter.name,
              field: filter.field,
              value: filterObject.value,
            })
          }

          if(this.visualFilters){
            const visualFilter = this.visualFilters.querySelector(`[data-category="${filter.name}"][value="${filterObject.value}"]`);
            if(visualFilter) {
              if(filterObject.selected) {
                visualFilter.checked = true;
              } else {
                visualFilter.checked = false;
              }
            }
          }

          const filterItem = document.createElement('li');
          filterItem.innerHTML = `
            <label>
              <input type="checkbox"
                name="${filter.field}"
                value="${filterObject.value}"
                data-category="${filter.name}"
                class="${isSwatchFilter ? 'filter__checkbox-hidden' : ''}"
                ${filterObject.selected ? 'checked="true"' : ""}>
              ${isSwatchFilter ? `
                <img class="filter__swatch" src="//www.outerknown.com/cdn/shop/files/${filterObject.value.replaceAll(' ', '-')}_swatch.jpg" loading="lazy" width="20" height="20" alt="" />
              ` : ''}
              <span class="filter-label">${filterObject.value}</span>
            </label>
          `

          filterListContainer.appendChild(filterItem);
        })
        this.filtersList.appendChild(filterEl);
      })

      this.buildActiveFilters(activeFilters);
    }

    sortFilterValues(values, sortmap) {
      return values.sort((a, b)=> {
        const a_index = isNaN(a.value) ? sortmap[a.value.toLowerCase()] : sortmap['number'];
        const b_index = isNaN(b.value) ? sortmap[b.value.toLowerCase()] : sortmap['number'];
        if (a_index === undefined) {
          return 1
        };
        if (b_index === undefined) {
          return -1
        };

        return a_index - b_index;
      })
    }

    buildActiveFilters(activeFilters) {
      const filterButtons = activeFilters.map(filter => {
        return `
          <button class="collection__active-filter" data-remove-filter data-filter-name="${filter.field}" data-filter-value="${filter.value}">
            ${filter.category}: ${filter.value}

            <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        `
      });

      if(filterButtons.length > 0) {
        filterButtons.push(`
          <button class="collection__active-filter collection__active-filter--clear-all" data-clear-all>
            Clear all
          </button>
        `)
      }

      if(activeFilters.length > 0) {
        this.mobileFilterClear.removeAttribute('hidden');
      } else {
        this.mobileFilterClear.setAttribute('hidden', true);
      }

      this.activeFiltersContainer.innerHTML = filterButtons.join('');
    }

    toggleFilterDrawerMobile() {
      if(this.classList.contains('collection--mobile-open')) {
        this.closeFilter('mobile');
      } else {
        this.openFilter('mobile');
      }
    }

    openFilter(size) {
      if(size == "desktop") {
        this.classList.add('collection--desktop-open');

        this.desktopFilterToggleBtn.innerText = "Hide Filters";
        trapFocus(this.filtersContainer, this.filtersContainer, true);
      } else {
        this.classList.add('collection--mobile-open');
        this.mobileFilterToggleBtn.innerText = "Hide Filters",
        trapFocus(this.filtersContainer, this.filtersContainer, true);
      }
    }

    closeFilter(size) {
      if(size == "desktop") {
        this.classList.remove('collection--desktop-open');

        this.desktopFilterToggleBtn.innerText = "Show Filters";
        trapFocus(this.filtersContainer, this.filtersContainer, true);
      } else {
        this.classList.remove('collection--mobile-open');
        this.mobileFilterToggleBtn.innerText = "Show Filters",
        trapFocus(this.filtersContainer, this.filtersContainer, true);
      }
    }

    toggleFilterDrawerDesktop() {
      if(this.classList.contains('collection--desktop-open')) {
        this.closeFilter('desktop');
      } else {
        this.openFilter('desktop');
      }
    }

    onFilterChange(evt) {
      const target = evt.target;
      const value = `${target.name}:${target.value}`

      if(target.type == "radio") {
        this.onSortChange(evt);

        return;
      }

      if(target.checked == true) {
        this.addFilter(value);
      } else {
        this.removeFilter(value)
      }

      this.getCollectionData({
        collection_from: 0,
        collection_reset: true,
        collection_direction: null,
        collection_size: this.collectionSize,
      })
    }

    onFiltersButtonClick(evt) {
      const target = evt.target;

      if(target.closest('button')) {
        if(target.dataset.closeFilters) {
          this.toggleFilterDrawerDesktop();
        }

        if(target.dataset.clearAll !== undefined) {
          this.clearFilters();
        }
      }

      if(target.tagName == "SUMMARY") {
        const filterIndex = this.openFilters.findIndex((el) => el == target.parentElement.dataset.name);
        if(target.parentElement.open) {
          if(filterIndex > -1) {
            this.openFilters.splice(filterIndex, 1);
          }
        } else {
          this.openFilters.push(target.parentElement.dataset.name);
        }
      }
    }

    onVisualFilterClick(evt) {
      const category = evt.target.dataset.category;
      const value = evt.target.value;

      this.filtersContainer.querySelector(`[data-category="${category}"][value="${value}"]`).click();
    }

    onFilterRemoveClick(evt) {
      const target = evt.target.closest('button');

      if(target.dataset.clearAll !== undefined) {
        this.clearFilters();
      } else {
        const filterCheckbox = this.filtersContainer.querySelector(`input[type="checkbox"][name="${target.dataset.filterName}"][value="${target.dataset.filterValue}"]`);

        if(filterCheckbox) {
          filterCheckbox.click();
        }
      }
    }

    addFilter(value) {
      const url = new URL(document.location.href);
      url.searchParams.append("f", value);
      url.searchParams.delete('page');

      history.replaceState('', null, url.toString());
    }

    removeFilter(value) {
      const url = new URL(document.location.href);
      url.searchParams.delete("f", value);
      url.searchParams.delete('page');

      history.replaceState('', null, url.toString());
    }

    clearFilters() {
      const url = new URL(document.location.href);
      url.searchParams.delete('f');
      url.searchParams.delete('page');

      history.replaceState('', null, url);

      this.getCollectionData({
        collection_from: 0,
        collection_reset: true,
        collection_size: this.collectionSize,
      })

      this.closeFilter('mobile');
    }

    buildProducts({ products, direction }) {
      const insertPosition = direction == 'before' ? "afterbegin" : "beforeend";
      products.forEach((product, index) => {
        let genderedMainImageIndex = false;
        let genderedHoverImageIndex = false;

        if(this.gendered == "mens") {
          genderedMainImageIndex = product.videoUnisex_mens_image_position;
          genderedHoverImageIndex = product.videoUnisex_mens_hover_image_position;
        } else if (this.gendered == "womens") {
          genderedMainImageIndex = product.videoUnisex_womens_image_position;
          genderedHoverImageIndex = product.videoUnisex_womens_hover_image_position;
        }
        this.productGrid.insertAdjacentHTML(insertPosition, `
          <li class="collection-grid__product" data-slot="${product.sIndex}">
            <v3-product-card
              data-url="${product.url}"
              id="${product.cardPosition}"
              class="skeleton-item"
              data-gendered="${this.gendered}"
              data-video-desktop="${product.videoDesktop}"
              data-video-mobile="${product.videoMobile}"
              data-gendered-image-index="${genderedMainImageIndex}"
              data-gendered-hover-image-index="${genderedHoverImageIndex}"
              ${index < 4 ? 'data-loading="eager"': ''}
            >
            </v3-product-card>
          </li>
        `)
      })
    }

    buildPromoSlots() {
      if(!Array.isArray(this.slotsPositions) || !Array.isArray(this.slotsIds) || !Array.isArray(this.slotsWidths)) return;

      this.slotsPositions.forEach((slotPosition, index) => {
        const populatedSlot = this.productGrid.querySelector(`li[data-promo-slot="${slotPosition}"]`);

        if(!populatedSlot) {
          const adjacentCard = this.productGrid.querySelector(`[data-slot="${slotPosition}"]`);
          if(adjacentCard) {
            adjacentCard.insertAdjacentHTML("beforebegin", `
              <li class="collection-grid__promotion collection-grid__promotion--${this.slotsWidths[index]}" data-promo-slot="${slotPosition}">
                <div class="nosto_element" id="${this.slotsIds[index]}"></div>
              </li>
            `)
          }
        }
      })

      nostojs((api) => {
        api
        .defaultSession()
        .setResponseMode("HTML")
        .viewFrontPage()
        .setPlacements(api.placements.getPlacements())
        .load()
        .then((response) => {
          api.placements.injectCampaigns(response.recommendations);
        })
      })
    }

    buildLoadButtons({ info, direction }) {
      const currentPage = (info.from / info.size) + 1;
      const maxPage = Math.ceil(info.total / info.size);
      const previousPagesCount = (currentPage - 1) * info.size;
      const childrenCount = previousPagesCount + info.hits.length;

      // Load pagination information
      if(direction != 'before') {
        this.itemsCount.innerText = childrenCount;
        this.itemsTotal.innerText = info.total;
      }

      if(this.loadPreviousBtn.dataset.observed != true) {
        this.intersectionObserver.observe(this.loadPreviousBtn);
        this.loadPreviousBtn.setAttribute('data-observed', true);
      }

      // Update load previous button
      if(currentPage > 1) {
        this.loadPreviousBtn.setAttribute('data-page', currentPage);
        this.loadPreviousBtn.style.opacity = 1;
      } else {
        this.loadPreviousBtn.parentElement.setAttribute('hidden', true);
        this.intersectionObserver.unobserve(this.loadPreviousBtn);
      }

      // Update load more button
      if(currentPage != maxPage) {
        if(direction != 'before') {
          this.loadMoreBtn.setAttribute('data-page', currentPage + 1);
          this.loadMoreBtn.removeAttribute('style');
        }
      } else {
        this.loadMoreBtn.style.display = "none";
      }
    }

    updateSortSelectors(value) {
      const radioSelect = this.filtersContainer.querySelector(`input[type="radio"][value="${value}"`);
      if(radioSelect) {

        this.sortSelects.forEach(el => {
          el.value = value
        })
        radioSelect.checked = true;
      }
    }

    onSortChange(evt) {
      const currentStatus = new URL(document.location.href);
      const newSort = evt.target.value;

      this.updateSortSelectors(newSort);

      if(newSort == "") {
        currentStatus.searchParams.delete('sort');
      } else {
        currentStatus.searchParams.set("sort", newSort);
      }

      currentStatus.searchParams.delete('page');

      history.replaceState('',null, currentStatus.toString())

      this.getCollectionData({
        collection_from: 0,
        collection_reset: true,
        collection_size: this.collectionSize,
      })
    }

    onLoadNextClick(evt) {
      const page = evt.target.dataset.page;
      const url = new URL(document.location.href);

      url.searchParams.set('page', page);

      history.replaceState('', null, url.toString());

      this.getCollectionData({
        from: this.collectionSize * page + this.collectionSize,
        collection_reset: false,
        collection_direction: evt.target.dataset.direction,
        collection_size: this.collectionSize,
        collection_from: this.collectionSize * page - this.collectionSize,
      })
    }

    fixScrollPosition() {
      const scrollDiff = this.productGrid.scrollHeight - this.gridHeight;

      window.scrollBy({
        top: scrollDiff
      })
    }

    onLoadPreviousClick(evt) {
      const page = evt.target.dataset.page;
      const url = new URL(document.location.href);

      url.searchParams.set('page', page);

      history.replaceState('', null, url.toString());

      this.gridHeight = this.productGrid.scrollHeight;

      this.getCollectionData({
        from: this.collectionSize * page + this.collectionSize,
        collection_reset: false,
        collection_direction: evt.target.dataset.direction,
        collection_size: this.collectionSize,
        collection_from: Math.max(this.collectionSize * page - (this.collectionSize * 2), 0),
      })
    }

    loadPreviousHandler(observerEntries) {
      observerEntries.forEach(entry => {
        if(entry.target.dataset.direction == "before" && entry.isIntersecting == true) {
          entry.target.click();
        }
      })
    }

    onCardClicked(evt) {
      const link = evt.target.closest('a[data-product-url]');
      const target = evt.target.closest('v3-product-card');

      if(link) {
        const currentPage = target.id.split('C')[0].replace('P', '');

        const url = new URL(document.location.href);
        url.searchParams.set('page', currentPage);
        url.hash = target.id;

        history.replaceState('', null, url.toString());
      }
    }

    disconnectedCallback() {
      this.eventsController.abort();
    }
  }

  customElements.define('v3-nosto-collection', V3NostoCollection);
}